import {
    animate,
    state,
    style,
    transition,
    trigger,
} from "@angular/animations";
import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LocalStorageService, SessionStorageService } from "ngx-webstorage";
import { MenuItem } from "primeng/api";
import { AppComponent } from "./app.component";

@Component({
    selector: "app-menu",
    template: `
        <ul
            app-submenu
            [item]="app.grouped ? modelGrouped : modelUngrouped"
            root="true"
            class="layout-menu"
            visible="true"
            [reset]="reset"
            parentActive="true"
        ></ul>
    `,
})
export class AppMenuComponent implements OnInit {
    isAdmin: boolean;
    b2biRoles=[1,2,3,6,7]
    sfgRoles=[4,5,6,7]
    userType: any;
    constructor(
        public app: AppComponent,
        public session: SessionStorageService,
        public localstorage: LocalStorageService,
        private router: Router
    ) { }

    @Input() reset: boolean;
    modelGrouped: any[];
    modelUngrouped: any[];
    UserDetails: any;
    isUserAdmin: boolean = false;
    isManufacturing: boolean = false;
    userName = "";
    userId = "";
    roleId: any;
    ngOnInit() {
        this.UserDetails = this.session.retrieve("UserDetails");
        this.userName = this.UserDetails === null ? "" : this.UserDetails.userName;
        this.userId = this.UserDetails === null ? "" : this.UserDetails.userId;
        this.roleId = this.UserDetails === null ? "" : this.UserDetails.roleId;
        this.userType = this.UserDetails === null ? "" : this.UserDetails.userType;
        this.isAdmin = this.roleId === 1 || this.userType === 'admin';
        this.modelGrouped = [
            {
                items: [
                    {
                        label: "Profile",
                        icon: "pi pi-fw pi-user",
                        routerLink: ["/mscvp/profile"],
                    },
                    {
                        label: "User Creation",
                        icon: "pi pi-fw pi-user-plus",
                        visible: this.isAdmin,
                        routerLink: ["mscvp/user-creation"],
                    },
                    {
                        label: "User Search",
                        icon: "pi pi-fw pi-search",
                        visible: this.isAdmin || this.roleId == 2,
                        routerLink: ["mscvp/user-search"],
                    },
                    {
                        label: "Scheduler",
                        icon: "pi pi-fw pi-bars",
                        visible: this.isAdmin,
                        routerLink: ["mscvp/scheduler"],
                    },
                    {
                        label: "Config",
                        icon: "pi pi-fw pi-cog",
                        visible: this.isAdmin,
                        routerLink: ["/mscvp/config"],
                    },
                     
                    
                ],
            },
            {
                label: "Dashboard",
                icon: "pi pi-fw pi-cog",
                items: [
                    {
                        label: "Daily Stats",
                        icon:  "pi pi pi-chart-bar",
                        routerLink: ["mscvp/daily-status-view"],
                    },
                    {
                        label: "TP Volumes",
                        icon: "pi pi-fw pi-briefcase",
                        visible: this.isAdmin,
                        routerLink: ["mscvp/m-dashboard"],
                    },
                    {
                        label: "Supplier Volumes",
                        icon: "pi pi-fw pi-chart-bar",
                        visible: this.isAdmin,
                        routerLink: ["mscvp/warehouse-volumes"],
                    },
                    {
                        label: "Document Repository",
                        icon: "pi pi-fw pi-bars",
                        routerLink: ["mscvp/m-doc-repository"],
                        visible: !this.isAdmin,  
                    },
                    {
                        label: "Document Stats",
                        // icon: "pi pi-fw pi-chart-pie",
                         icon: 'pi pi pi-chart-bar',
                        routerLink: ["mscvp/doc-stats"],
                        visible: this.sfgRoles.includes(this.roleId),
                    },
                    {
                        label: "Reports",
                        // icon: "pi pi-fw pi-chart-pie",
                         icon: 'pi pi pi-chart-bar',
                        routerLink: ["mscvp/webforms-reports"],
                        visible: this.sfgRoles.includes(this.roleId),
                    },
                    {
                        label: "My Exports",
                        icon: "pi pi-fw pi-arrow-circle-down",
                        routerLink: ["/mscvp/xl-downloads"],
                        visible: !this.isAdmin
                    },
                    
                    // {
                    //     label: "Error Handling Reports",
                    //     // icon: "pi pi-fw pi-chart-pie",
                    //      icon: 'pi pi pi-chart-bar',
                    //     routerLink: ["mscvp/error-handling"],
                    //     visible: this.sfgRoles.includes(this.roleId),
                    // },
                    {
                        label: "Partners",
                        icon: "pi pi-fw pi-users",
                        routerLink: ["mscvp/partner"],
                        visible: this.isAdmin,  
                    },
                ],
            },
            {
                label: "Sterling B2B Integrator",
                icon: "pi pi-fw pi-cog",
                visible: this.b2biRoles.includes(this.roleId) || this.isAdmin,
                items: [
                    {
                        label: "Document Repository",
                        icon: "pi pi-fw pi-bars",
                        routerLink: ["mscvp/m-doc-repository"],
                    },
                    {
                        label: "Document Stats",
                        icon: 'pi pi pi-chart-bar',
                        routerLink: ["mscvp/doc-stats"],
                        visible: this.sfgRoles.includes(this.roleId) || this.isAdmin,
                    },
                    {
                        label: "Division",
                        icon: "pi pi-fw pi-home",
                        routerLink: ["mscvp/division"],
                    },
                    {
                        label: "Partners",
                        icon: "pi pi-fw pi-users",
                        routerLink: ["mscvp/partner"],
                    },
                    {
                        label: "Archive & Purge",
                        icon: "pi pi-fw pi-trash",
                        visible: this.isAdmin, 
                        routerLink: ["mscvp/archive-purge"],
                    },
                    {
                        label: "My Exports",
                        icon: "pi pi-fw pi-arrow-circle-down",
                        routerLink: ["/mscvp/xl-downloads"],
                    },
                ],
            },
            {
                label: "Sterling File Gateway",
                icon: "pi pi-fw pi-th-large",
                // visible: this.sfgRoles.includes(this.roleId) || this.isAdmin,
                visible: this.roleId != 4 || this.isAdmin,
                items: [
                    {
                        label: "Document Repository",
                        icon: "pi pi-fw pi-bars",
                        routerLink: ["mscvp/sfgRepo"],
                    },
                    {
                        label: "Partners",
                        icon: "pi pi-fw pi-users",
                        routerLink: ["mscvp/sfg-partner"],
                        visible: this.isAdmin, 
                    },
                    {
                        label: "Archive & Purge",
                        icon: "pi pi-fw pi-trash",
                        routerLink: ["mscvp/sfg-archive-purge"],
                        visible: this.isAdmin, 
                    },
                   
                ],
                
            },
            {
                label: "Trading Partner Management",
                icon: "pi pi-fw pi-th-large",
                visible: this.sfgRoles.includes(this.roleId) || this.isAdmin,
                items: [
                    {
                        label: "Trading Partner Search",
                        icon: "pi pi-search",
                        routerLink: ["mscvp/trading-partner"],
                    },
                    {
                        label: "Trading Partner Set Up",
                        icon: "pi pi-user-plus",
                        routerLink: ["mscvp/trading-partner-setup"],
                    },
                ]
            }
        ];
    }
    
}

@Component({
    /* tslint:disable:component-selector */
    selector: "[app-submenu]",
    /* tslint:enable:component-selector */
    template: `
        <ng-template
            ngFor
            let-child
            let-i="index"
            [ngForOf]="root ? item : item.items"
        >
            <li
                [ngClass]="{
                    'layout-root-menuitem': root,
                    'active-menuitem': isActive(i)
                }"
                [class]="child.badgeStyleClass"
                *ngIf="child.visible === false ? false : true"
            >
                <div *ngIf="root" [ngClass]="child.label ? 'heading' : ''" >
                    <span class="layout-menuitem-text">{{ child.label }}</span>
                </div>
                <a
                    [href]="child.url || '#'"
                    (click)="itemClick($event, child, i)"
                    (mouseenter)="onMouseEnter(i)"
                    *ngIf="!child.routerLink"
                    [class]="child.styleClass"
                    [attr.tabindex]="!visible ? '-1' : null"
                    [attr.target]="child.target"
                >
                    <i class="layout-menuitem-icon" [ngClass]="child.icon"></i>
                    <span class="layout-menuitem-text">{{ child.label }}</span>
                    <i
                        class="pi pi-fw pi-angle-down layout-submenu-toggler"
                        *ngIf="child.items"
                    ></i>
                    <span class="menuitem-badge" *ngIf="child.badge">{{
                        child.badge
                    }}</span>
                </a>
                <a
                    (click)="itemClick($event, child, i)"
                    (mouseenter)="onMouseEnter(i)"
                    *ngIf="child.routerLink"
                    [routerLink]="child.routerLink"
                    routerLinkActive="active-route"
                    [fragment]="child.fragment"
                    [routerLinkActiveOptions]="{ exact: true }"
                    [attr.tabindex]="!visible ? '-1' : null"
                    [attr.target]="child.target"
                >
                    <i class="layout-menuitem-icon" [ngClass]="child.icon"></i>
                    <span class="layout-menuitem-text">{{ child.label }}</span>
                    <i
                        class="pi pi-fw pi-angle-down layout-menuitem-toggler"
                        *ngIf="child.items"
                    ></i>
                    <span class="menuitem-badge" *ngIf="child.badge">{{
                        child.badge
                    }}</span>
                </a>
                <div class="layout-menu-tooltip">
                    <div class="layout-menu-tooltip-arrow"></div>
                    <div class="layout-menu-tooltip-text">
                        {{ child.label }}
                    </div>
                </div>
                <ul
                    app-submenu
                    [item]="child"
                    *ngIf="child.items"
                    [visible]="isActive(i)"
                    [reset]="reset"
                    [parentActive]="isActive(i)"
                    [@children]="
                        (app.isSlim() || app.isHorizontal()) &&
                        !app.isMobile() &&
                        root
                            ? isActive(i)
                                ? 'visible'
                                : 'hidden'
                            : isActive(i)
                            ? 'visibleAnimated'
                            : app.grouped === true && root
                            ? 'visibleAnimated'
                            : 'hiddenAnimated'
                    "
                ></ul>
            </li>
        </ng-template>
    `,
    animations: [
        trigger("children", [
            state(
                "hiddenAnimated",
                style({
                    height: "0px",
                })
            ),
            state(
                "visibleAnimated",
                style({
                    height: "*",
                })
            ),
            state(
                "visible",
                style({
                    height: "*",
                    "z-index": 100,
                })
            ),
            state(
                "hidden",
                style({
                    height: "0px",
                    "z-index": "*",
                })
            ),
            transition(
                "visibleAnimated => hiddenAnimated",
                animate("400ms cubic-bezier(0.86, 0, 0.07, 1)")
            ),
            transition(
                "hiddenAnimated => visibleAnimated",
                animate("400ms cubic-bezier(0.86, 0, 0.07, 1)")
            ),
        ]),
    ],
})
export class AppSubMenuComponent {
    constructor(public app: AppComponent, public appMenu: AppMenuComponent) {}
    @Input() item: MenuItem;
    @Input() root: boolean;
    @Input() visible: boolean;
    _parentActive: boolean;
    _reset: boolean;
    activeIndex: number;

    itemClick(event: Event, item: MenuItem, index: number) {
        if (this.root) {
            this.app.menuHoverActive = !this.app.menuHoverActive;
        }
        // avoid processing disabled items
        if (item.disabled) {
            event.preventDefault();
            return true;
        }

        // activate current item and deactivate active sibling if any
        this.activeIndex = this.activeIndex === index ? null : index;

        // execute command
        if (item.command) {
            item.command({ originalEvent: event, item });
        }

        // prevent hash change
        if (item.items || (!item.url && !item.routerLink)) {
            setTimeout(() => {
                this.app.layoutMenuScrollerViewChild.moveBar();
            }, 450);
            event.preventDefault();
        }

        // hide menu
        if (!item.items) {
            if (this.app.isHorizontal() || this.app.isSlim()) {
                this.app.resetMenu = true;
            } else {
                this.app.resetMenu = false;
            }

            this.app.overlayMenuActive = false;
            this.app.staticMenuMobileActive = false;
            this.app.menuHoverActive = !this.app.menuHoverActive;
        }
    }

    onMouseEnter(index: number) {
        if (
            this.root &&
            this.app.menuHoverActive &&
            (this.app.isHorizontal() || this.app.isSlim()) &&
            !this.app.isMobile() &&
            !this.app.isTablet()
        ) {
            this.activeIndex = index;
        }
    }

    isActive(index: number): boolean {
        return this.activeIndex === index;
    }

    @Input() get reset(): boolean {
        return this._reset;
    }

    set reset(val: boolean) {
        this._reset = val;

        if (this._reset && (this.app.isHorizontal() || this.app.isSlim())) {
            this.activeIndex = null;
        }
    }

    @Input() get parentActive(): boolean {
        return this._parentActive;
    }

    set parentActive(val: boolean) {
        this._parentActive = val;

        if (!this._parentActive) {
            this.activeIndex = null;
        }
    }
}
